import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nyt produkt',
  fields: {
    type: {
      label: 'Produkttype',
      options: {
        [SubscriptionProductType.Plan]: 'Abonnement',
        [SubscriptionProductType.AddOn]: 'Tilkøb',
        [SubscriptionProductType.GoogleAdsPlan]: 'Google Ads-abonnement',
      },
    },
    name: {
      label: 'Internt navn',
      placeholder: 'Indtast produktets interne navn',
    },
    public_name: {
      label: 'Offentligt navn',
      placeholder: 'Indtast produktets offentlige navn',
    },
    description: {
      label: 'Beskrivelse',
    },
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
  },
  feedback: {
    missing_info: 'Manglende oplysninger',
  },
  toasts: {
    plan_got_created: 'Produktet blev oprettet',
    plan_got_updated: 'Produktet blev opdateret',
  },
};
